__turbopack_context__.v({
  "expand": "product-gallery-module-scss-module__8C_ddq__expand",
  "frame": "product-gallery-module-scss-module__8C_ddq__frame",
  "gallery": "product-gallery-module-scss-module__8C_ddq__gallery",
  "zoom": "product-gallery-module-scss-module__8C_ddq__zoom",
});
